module.exports = __webpack_public_path__ + "static/media/read.aa518363.svg";